module.exports = __webpack_public_path__ + "de869ee828f14518c24fa1751b29275a.png";